"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNetworkError = void 0;
var isNetworkError = function (message) {
    if (typeof message === "string") {
        var lowerCasedMessage = message === null || message === void 0 ? void 0 : message.toLowerCase();
        return (lowerCasedMessage.includes("response is null") || lowerCasedMessage.includes("network request failed") || lowerCasedMessage.includes("http error") || lowerCasedMessage.includes("networkerror"));
    }
    return false;
};
exports.isNetworkError = isNetworkError;
